import React from 'react';
import { AboutBadge } from '../AboutBadge';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const categories = [
  { title: 'Генподрядчики', image: '/img.png' },
  { title: 'Субподрядчики', image: '/img_1.png' },
  { title: 'Производители стройматериалов', image: '/img_3.png' },
  { title: 'Владельцы спецтехники', image: '/img_4.png' },
  {
    title: 'Аутсорс кадры из строительной индустрии',
    image: '/img_6.png',
  },
];

export function SectionRegistered() {
  return (
    <section className="bg-white rounded-[48px] p-[60px_0] m-4 relative z-[1] overflow-hidden">
      <div className="px-[100px] max-[1024px]:px-[50px] max-[768px]:px-[20px]">
        <AboutBadge text="На площадке зарегистрированы" />
        <div className="mt-8">
          <Swiper
            slidesPerView={5}
            spaceBetween={20}
            breakpoints={{
              1280: { slidesPerView: 5 },
              1024: { slidesPerView: 4 },
              768: { slidesPerView: 3 },
              480: { slidesPerView: 2 },
              320: { slidesPerView: 1 },
            }}
            className="mt-8"
          >
            {categories.map((category, index) => (
              <SwiperSlide key={index} className="flex items-stretch h-auto">
                <div className="p-4 min-h-[230px] rounded-[20px] bg-[#f0f5ff] text-center flex flex-col justify-center items-center w-full max-[768px]:min-h-[200px] max-[768px]:p-3 max-[480px]:min-h-[180px] max-[480px]:p-2">
                  <h3 className="mt-2 text-[18px] font-semibold text-center max-w-[90%] break-words max-[768px]:text-[16px] max-[480px]:text-[14px]">
                    {category.title}
                  </h3>
                  <div className="w-full h-[120px] flex justify-center items-center overflow-hidden max-[768px]:h-[100px] max-[480px]:h-[80px]">
                    <img
                      src={category.image}
                      alt={category.title}
                      className="max-w-full max-h-full object-contain rounded"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
